/**
* LoginFormMdule is a reusable Module to use the login module features
*/

// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

// Modules
import { ButtonModule } from '../../fields/button/button.module';
import { TextFieldModule } from '../../fields/text-field/text-field.module';

// Own Components
import { LoginFormComponent } from './login-form.component';

// Own fieldsets
import { LoginFieldsetComponent } from '../../fieldsets/login-fieldset/login-fieldset.component';

// Services
import { FormBuilderService } from '../../../../service/formBuilder/formBuilder.service';
import { FormService }  from "../../../../service/form/form.service";
import { HttpClientModule } from '@angular/common/http';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ButtonModule,
        TextFieldModule,
        HttpClientModule
    ],
    declarations: [
        LoginFormComponent,
        LoginFieldsetComponent
    ],
    exports: [
        LoginFormComponent,
        LoginFieldsetComponent
    ],
    providers: [
        FormBuilderService,
        FormService
    ]
})
export class LoginFormModule { }
